import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ProductCardComponent } from 'src/business/product/components/product-card/product-card.component';
import { ProductCardModel, SearchClient } from 'src/business/services/client.generated';
import { BASE_URL, LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { DialogModule } from 'src/layout/dialog/dialog.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { UmbracoGrid } from 'src/layout/grid/models/umbraco-grid.type';
import { MediaModule } from 'src/layout/media/media.module';
import { debounce } from 'src/utils/debounce';
import { StorageUtil } from 'src/utils/storage.util';
import { UrlUtil } from 'src/utils/url.util';
import { Uuid } from 'src/utils/uuid.util';

@Component({
    selector: 'app-header-search',
    standalone: true,
    imports: [TranslateModule, MediaModule, ProductCardComponent, RouterModule, GridModule, DialogModule, CommonModule, TagManagerModule],
    templateUrl: './header-search.component.html',
    styleUrl: './header-search.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderSearchComponent {
    private _searchClient: SearchClient;
    _search = debounce(() => {

        var searchTerms = window[this.modalId].querySelector('[type="search"]').value;
        if (searchTerms?.length > 0)
            this._searchClient
                .search(this._language, { from: 0, size: 10, facets: {}, tags: [], searchTerms, sorting: null })
                .then(response => this.result$.next(response?.results ?? []));
        else
            this.result$.next([]);

    }, 750);
    layout: UmbracoGrid;
    modalId: string = 'search-' + Uuid.create();

    @HostBinding('style.--button-top.px')
    buttonTop: number;

    result$: BehaviorSubject<ProductCardModel[]>;

    constructor(
        @Inject(BASE_URL)
        private _baseUrl: string,
        @Inject(LANGUAGE)
        private _language: string,
        private _router: Router,
    ) {
        this.result$ = new BehaviorSubject<ProductCardModel[]>([]);
        this._searchClient = new SearchClient(this._baseUrl);
        this.layout = StorageUtil.get<{ searchLayout: UmbracoGrid }>('menu')?.searchLayout ?? [];
    }

    openModal(top: number) {
        window[this.modalId].showModal();
        this.buttonTop = top;
    }
    focus() {
        queueMicrotask(() => {
            window[this.modalId]
                .querySelector('[type="search"]')
                .value = '';
            window[this.modalId]
                .querySelector('[type="search"]')
                .focus()
        }
        );
    }
    goToSearch(event: SubmitEvent) {
        let value = window[this.modalId]?.querySelector('[type="search"]')?.value ?? '';
        if (value.trim().length == 0)
            return false;
        var searchPath: string = Object.entries(StorageUtil.get<{ [key: string]: string }>('routing')).find(([path, alias]) => alias == 'searchPage')[0];
        var _url = new URL(searchPath, window.origin);
        _url.searchParams.set(UrlUtil.SEARCH_PREFIX, value);

        this._router.navigateByUrl(_url.pathname + _url.search);
        return false;
    }
    search(event: SubmitEvent) {
        this._search();
        return false;
    }
}
